import React from "react";
import { Box, FormControlLabel, Switch, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const SwitchWithLabel = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch With Label
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          a Label is added next to the switch.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"with label, with label required and disabled with label"}
          language={"js"}
          value={
            "           <FormControlLabel\n" +
            '            control={<Switch defaultChecked color={"primary"} />}\n' +
            '            label="Label"\n' +
            "          />\n" +
            "          <FormControlLabel\n" +
            "            required\n" +
            '            control={<Switch color={"primary"} />}\n' +
            '            label="Required"\n' +
            "          />\n" +
            "          <FormControlLabel\n" +
            "            disabled\n" +
            '            control={<Switch color={"primary"} />}\n' +
            '            label="Disabled"\n' +
            "          />\n" +
            "        </PreviewAndEditor>"
          }
        >
          <FormControlLabel
            control={<Switch defaultChecked color={"primary"} />}
            label="Label"
          />
          <FormControlLabel
            required
            control={<Switch color={"primary"} />}
            label="Required"
          />
          <FormControlLabel
            disabled
            control={<Switch color={"primary"} />}
            label="Disabled"
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default SwitchWithLabel;
